/** Vite env → auth runtime config. Never put secrets here. */

function env(name: string, fallback = ''): string {
  const v = (import.meta.env[name] as string | undefined) ?? fallback
  return v.trim()
}

function flag(name: string, fallback: boolean): boolean {
  const raw = env(name, fallback ? 'true' : 'false').toLowerCase()
  if (raw === 'true' || raw === '1' || raw === 'yes') return true
  if (raw === 'false' || raw === '0' || raw === 'no') return false
  return fallback
}

export interface AuthConfig {
  keycloakUrl: string
  realm: string
  clientId: string
  /** When true and OIDC is unavailable (or for local UI), demo session is allowed. */
  allowDemoAuth: boolean
}

export function getAuthConfig(): AuthConfig {
  return {
    keycloakUrl: env('VITE_KEYCLOAK_URL').replace(/\/$/, ''),
    realm: env('VITE_KEYCLOAK_REALM', 'genesis'),
    clientId: env('VITE_KEYCLOAK_CLIENT_ID', 'bookmaker-ui-console'),
    // Prod images bake false. Local: set VITE_ALLOW_DEMO_AUTH=true in .env only.
    allowDemoAuth: flag('VITE_ALLOW_DEMO_AUTH', false),
  }
}

export function isOidcConfigured(cfg: AuthConfig = getAuthConfig()): boolean {
  return Boolean(cfg.keycloakUrl && cfg.realm && cfg.clientId)
}

export function oidcBase(cfg: AuthConfig = getAuthConfig()): string {
  return `${cfg.keycloakUrl}/realms/${cfg.realm}/protocol/openid-connect`
}

/**
 * Keycloak Account Console — signing-in / MFA manage (TOTP, passkeys, recovery).
 * KC 26 Account UI hash route; null when OIDC base URL is not configured.
 */
export function accountSecurityUrl(cfg: AuthConfig = getAuthConfig()): string | null {
  if (!isOidcConfigured(cfg)) return null
  return `${cfg.keycloakUrl}/realms/${cfg.realm}/account/#/security/signingin`
}
